import {Publisher} from '../publisher.model';
import {KeyLabel} from '../key-label.model';

export enum UserType{
  CM_USER = 'CM_USER',
  PUBLISHER = 'PUBLISHER',
  DEMAND_PARTNER = 'DEMAND_PARTNER',
}
export const UserTypeLabels = {
  CM_USER: 'Kitchen',
  PUBLISHER: 'Publisher',
  DEMAND_PARTNER: 'Demand partner',
};

export const UserTypeLabelsKL = () =>
  (Object.keys(UserType).map(key => new KeyLabel(<UserType>key, UserTypeLabels[key])));
